export default __webpack_public_path__ + "assets/07f7ac0cb4fe66ba5357220bbecd8610.png";